import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { HealthOrganizationData } from 'src/app/core/model/v2/practice/HealthOrganizationData';
import { CommonService } from 'src/app/core/services/v2/common.service';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { SideBarComponentInterface } from 'src/app/shared/components/dynamic-right-sidebar/sideBarComponentInterface';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-setup-organization-editor',
  templateUrl: './setup-organization-editor.component.html',
  styleUrls: ['./setup-organization-editor.component.scss']
})
export class SetupOrganizationEditorComponent implements OnInit, SideBarComponentInterface {

  constructor(private practiceService : PracticeService, private loaderService: WindowLoaderService, private commonService: CommonService) { }
  title: string = "Organization";

  hoDto: HealthOrganizationData;
  form: FormGroup= new FormGroup({});;


  setData(data: any) {
    this.hoDto = data;
  }

  saveHoChanges()
  {
    this.hoDto = this.form.value;
    this.loaderService.blockWithLoader(this.practiceService.updateHealthOrganizationData(this.hoDto))
    .subscribe( r => 
      {
        this.hoDto = r.result;
          this.closeSidebar();
      } );
    
  }

  closeSidebar()
  {
    this.commonService.closeRightSideBar$.next();    
  }
  

  ngOnInit() {
  }

}
